/**
 * Disk template.
 */
import Animator from '@components/elements/animator/animator';
import DiskCapacityBar from '@components/atoms/container/diskCapacityBar';
import DiskCapacityBarInfo from '@components/atoms/text/diskCapacityBarInfo';
import DiskCapacityBarMaxCapacity from '@components/atoms/text/diskCapacityBarMaxCapacity';
import DiskCapacityCloud from '@components/atoms/images/diskCapacityCloud';
import DiskCapacityContainer from '@components/atoms/container/diskCapacityContainer';
import DiskCapacityInfo from '@components/atoms/text/diskCapacityInfo';
import DiskCapacityInnerBar from '@components/atoms/container/diskCapacityInnerBar';
import DiskCapacityOuterBar from '@components/atoms/container/diskCapacityOuterBar';
import DiskCapacityTitle from '@components/atoms/text/diskCapacityTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useDiskTemplate, { Props } from '../lib/useDiskTemplate';
import { DELAY } from '@shared/types/constants/animations';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Constants
 */
const LITERALS = 'PAGES.SETTINGS.DISK';

/**
 * Disk template component.
 */
export default function DiskTemplate(parentProps: Props) {
  const { callbacks, literals, props } = useDiskTemplate(parentProps);
  const menuExpanded = !useAppSelector(selectMenuCollapse);

  return (
    <Animator
      id={'diskContainer'}
      type={Animator.Type.SETTING}
      collapse={{ horizontal: menuExpanded }}
      {...callbacks.mainContainer}
    >
      <DiskCapacityContainer delay={DELAY.DISK}>
        <DiskCapacityTitle>
          {TranslationManager.get(`${LITERALS}.TITLE`)}
        </DiskCapacityTitle>
        <DiskCapacityInfo>
          {literals.info}
          <br></br>
          <br></br>
          {literals.detail}
        </DiskCapacityInfo>
        <DiskCapacityBar>
          <DiskCapacityCloud />
          <DiskCapacityOuterBar>
            <DiskCapacityInnerBar {...props.diskCapacityInnerBar} />
            <DiskCapacityBarInfo id={'diskCapacityBarInfo'}>
              {literals.barInfo}
            </DiskCapacityBarInfo>
          </DiskCapacityOuterBar>
          <DiskCapacityBarMaxCapacity id={'diskCapacityBarMaxCapacity'}>
            {literals.maxCapacity}
          </DiskCapacityBarMaxCapacity>
        </DiskCapacityBar>
      </DiskCapacityContainer>
    </Animator>
  );
}
